/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Blog_Read_LinkInputs */

const en_blog_read_link = /** @type {(inputs: Blog_Read_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Read the guide`)
};

const lv_blog_read_link = /** @type {(inputs: Blog_Read_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lasīt rakstu`)
};

/**
* | output |
* | --- |
* | "Read the guide" |
*
* @param {Blog_Read_LinkInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const blog_read_link = /** @type {((inputs?: Blog_Read_LinkInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Blog_Read_LinkInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_blog_read_link(inputs)
	return en_blog_read_link(inputs)
});